export default __webpack_public_path__ + "media/src/assets/images/PhoneIcon-da50fb68905d92c5f34dc1b8fe341079.svg";